export default __webpack_public_path__ + "static/media/background-login.60f3349b.png";